import type { Dispatch } from '@reduxjs/toolkit';
import { Spacing } from '@vkontakte/vkui';
import disableAdsImage from 'img/freemium/noAddFreemium.png';
import React from 'react';
import { freemiumTypeParam, FreemiumTypes, isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { closeCommonWhatsNewDialog, renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { BillingActions } from 'reactApp/modules/billing/billing.module';
import { openFreemiumFeaturesModal } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.helpers';
import type { FreemiumFeaturesModalData } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.types';

import { defaultModalProps } from '../FreemiumOnboardBanner/FreemiumOnboardBanner.helpers';
import { createFreemiumModalOpenHandler } from '../FreemiumTestUnlimitedModal/FreemiumTestUnlimitedModal.helpers';
import { sendFreemiumDisableAdsModalDwh } from './FreemiumDisableAdsModal.helpers';

interface FreemiumDisableAdsModalProps {
    dispatch: Dispatch;
    onClose?: () => void;
    onClick?: () => void;
    onShowMore?: () => void;
}

export const renderFreemiumDisableAdsModal = ({ dispatch, onClose, onClick }: FreemiumDisableAdsModalProps): void => {
    const analyticsName = isHardFreemium
        ? 'mnz_family_hard_freemium_disable_adv_info'
        : isSoftFreemium
        ? 'mnz_family_soft_freemium_disable_adv'
        : 'mnz_family_trial_freemium_disable_adv';

    const modalProps: FreemiumFeaturesModalData = freemiumTypeParam
        ? defaultModalProps[freemiumTypeParam]
        : defaultModalProps[FreemiumTypes.control];

    const modalOpen = createFreemiumModalOpenHandler(dispatch, 'family_unlimited_trial_disable_adv');

    const handleShow = () => {
        sendFreemiumDisableAdsModalDwh('show', analyticsName);
    };

    const handleClose = () => {
        sendFreemiumDisableAdsModalDwh('close', analyticsName);
        onClose?.();
    };

    const handleClick = () => {
        closeCommonWhatsNewDialog();
        sendFreemiumDisableAdsModalDwh('click', analyticsName);

        if (isHardFreemium) {
            dispatch(BillingActions.getFreemium());
        }
        openFreemiumFeaturesModal({
            ...modalProps,
            title: isHardFreemium ? 'Теперь реклама в Почте и Облаке отключится — на 7 дней' : modalProps.title,
            onButtonClick: modalOpen,
            dwhName: isHardFreemium
                ? 'mnz_family_hard_freemium_disable_adv'
                : isSoftFreemium
                ? 'mnz_family_soft_freemium_disable_adv'
                : 'mnz_family_trial_freemium_disable_adv',
        });
        onClick?.();
    };

    renderCommonWhatsNewDialog({
        title: (
            <>
                Отключите рекламу в Почте и Облаке — <br />с пробной подпиской на 7 дней
            </>
        ),
        content: (
            <>
                <Spacing size={12} />
                Баннеры не будут отвлекать от дел, и снизится уровень инфошума. <br />
                Попробуйте бесплатно — даже карту привязывать не нужно
                <Spacing size={24} />
            </>
        ),
        imageUrl: disableAdsImage,
        primaryButtonText: 'Попробовать бесплатно',
        closable: true,
        closeOnEscape: true,
        closeOnDimmerClick: true,
        onClick: handleClick,
        onClose: handleClose,
        onShow: handleShow,
        buttonTheme: 'vk',
        dialogSize: 'large',
    });
};
